/* eslint-disable react/react-in-jsx-scope */
// import { $, e } from '../elemental'
import { popup } from "../popup";
// eslint-disable-next-line no-unused-vars
import { node, Html, HtmlElement } from "venuescanner-js/tools/jsx";
const confirm = function (text, confirmed, rejected) {
  // if (typeof (text) === 'string') text = $('<div>').html(text)
  // console.log(typeof text, text)
  try {
    let message = (
      <div class="confirm-dialog">
        {typeof text === "string" ? (
          <p class="confirm-dialog__message">{text}</p>
        ) : text instanceof HTMLElement ? (
          <HtmlElement element={text} />
        ) : (
          text
        )}
        <div class="centered">
          <vs-btn
            type="skeleton"
            onClick={() => {
              popup.close();
              rejected();
            }}
          >
            Go back
          </vs-btn>
          <Html text="&nbsp;" />
          <vs-btn
            type="primary"
            onClick={() => {
              popup.close();
              confirmed();
            }}
          >
            Confirm
          </vs-btn>
        </div>
      </div>
    );
    // console.log(message)
    popup.new(message);
  } catch (e) {
    console.error(e);
  }
};

export { confirm };
